<template>
    <v-container>
      <!-- 頂部操作列 -->
      <div class="d-flex align-center mb-6">
        <v-text-field
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          placeholder="輸入學校名稱、教師姓名或帳號"
          outlined
          dense
          hide-details
          class="flex-grow-1 mr-4"
        ></v-text-field>
        
        <v-btn
          color="black"
          dark
          class="mr-2"
          @click="downloadCSV"
        >
          下載CSV
        </v-btn>
        
        <v-btn
          color="black"
          dark
          @click="addSchoolAccount"
        >
          新增帳號
        </v-btn>
      </div>
  
      <!-- 教師列表 -->
      <div v-for="(group, index) in filteredSchoolAccounts" :key="index">
        <div class="d-flex align-center my-4">
          <div class="text-h6 font-weight-bold text-left">{{ group.schoolName }}</div>
          <v-divider class="flex-grow-1 ml-2"></v-divider>
        </div>
        
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th>姓名</th>
                <th>帳號</th>
                <th>密碼</th>
                <th>信箱</th>
                <th class="text-right">操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="schoolAccount in group.accounts" :key="schoolAccount.id">
                <td class="text-left">{{ schoolAccount.name }}</td>
                <td class="text-left">{{ schoolAccount.username }}</td>
                <td class="text-left">{{ schoolAccount.password }}</td>
                <td class="text-left">{{ schoolAccount.email }}</td>
                <td class="text-right">
                  <v-icon
                    small
                    class="mr-2"
                    @click="editSchoolAccount(schoolAccount)"
                  >
                    mdi-pencil
                  </v-icon>
                  <v-icon
                    small
                    @click="deleteSchoolAccount(schoolAccount)"
                  >
                    mdi-delete
                  </v-icon>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
  
      <!-- Add this dialog component -->
      <v-dialog v-model="deleteDialog" max-width="300">
        <v-card>
          <v-card-title class="text-h6">
            確定刪除帳號嗎?
             </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="grey darken-1"
              text
              @click="deleteDialog = false"
            >
              取消
            </v-btn>
            <v-btn
              color="error"
              text
              @click="confirmDelete"
            >
              刪除
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  
      <!-- Add Account Dialog -->
      <v-dialog v-if="addDialog" v-model="addDialog" max-width="1000">
        <v-card>
          <v-card-title class="text-h6">
            選擇學校及系所資訊
          </v-card-title>
          
          <v-card-text>
            <v-row>
              <v-col cols="4">
                <v-select v-model="newAccount.school" :items="schoolsList" item-text="name" item-value="_id" label="學校" outlined></v-select>
              </v-col>
            </v-row>

            <v-row align="center" class="mb-4">
              <v-col cols="2">
                <v-btn small icon @click="decrementCount">
                  <v-icon>mdi-minus</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="8">
                <v-text-field
                  v-model="accountCount"
                  type="number"
                  outlined
                  dense
                  hide-details
                  class="text-center"
                  disabled
                  @change="initializeNewAccounts"
                ></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-btn small icon @click="incrementCount">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>

            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>姓名</th>
                    <th>帳號</th>
                    <th>密碼</th>
                    <th>信箱</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="i in parseInt(accountCount)" :key="i">
                    <td class="text-left">{{ newAccounts[i-1].name }}</td>
                    <td class="text-left">{{ newAccounts[i-1].username }}</td>
                    <td class="text-left">{{ newAccounts[i-1].password }}</td>
                    <td class="text-left">{{ newAccounts[i-1].email }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="grey darken-1"
              text
              @click="closeAddDialog"
            >
              取消
            </v-btn>
            <v-btn
              color="black"
              dark
              @click="confirmAdd"
            >
              新增
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  
      <!-- Success Dialog -->
      <v-dialog v-model="successDialog" max-width="300">
        <v-card>
          <v-card-title class="text-h6 justify-center">
            新增帳號成功
          </v-card-title>
          <v-card-actions class="justify-center">
            <v-btn
              color="black"
              text
              @click="successDialog = false"
            >
              完成
            </v-btn>
            <v-btn
              color="black"
              dark
              @click="downloadAddedCSV"
            >
              下載CSV檔
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  
      <!-- Edit Teacher Dialog -->
      <v-dialog v-model="editDialog" max-width="1000">
        <v-card class="pa-6">
          <!-- Header Section -->
          <div class="d-flex align-center mb-8">
            <div>
              <div class="text-h5 font-weight-bold text-left">編輯學校管理員資料</div>
              <div class="text-subtitle-1 grey--text text-left">{{ editingSchoolAccount.school.name }}</div>
            </div>
            <v-spacer></v-spacer>
          </div>

          <!-- Profile Form -->
          <v-form>
            <v-row>
              <!-- 姓名 -->
              <v-col cols="12" md="4">
                <v-text-field v-model="editingSchoolAccount.name" label="姓名" outlined></v-text-field>
              </v-col>
              <!-- 帳號 -->
              <v-col cols="12" md="4">
                  <v-text-field v-model="editingSchoolAccount.username" label="帳號" outlined></v-text-field>
              </v-col>
              <!-- 密碼 -->
              <v-col cols="12" md="4">
                <v-text-field v-model="editingSchoolAccount.password" label="密碼" outlined></v-text-field>
              </v-col>
              <!-- 信箱 -->
              <v-col cols="12" md="4">
                  <v-text-field v-model="editingSchoolAccount.email" label="信箱" outlined></v-text-field>
              </v-col>
              <!-- 電話 -->
              <v-col cols="12" md="4">
                <v-text-field v-model="editingSchoolAccount.phone" label="電話" outlined></v-text-field>
              </v-col>
              <!-- 學校 -->
              <v-col cols="12" md="4">
                <v-select v-model="editingSchoolAccount.school" :items="schoolsList" item-text="name" item-value="_id" label="學校" outlined></v-select>
              </v-col>
            </v-row>
          </v-form>
          <v-card-actions class="pt-6">
        <v-spacer></v-spacer>
        <v-btn color="black" dark height="44" @click="confirmEdit"
            style="border-radius: 10px;width: 15rem;">
            完成
        </v-btn>
        <v-spacer></v-spacer>
    </v-card-actions>
        </v-card>
      </v-dialog>
      
    </v-container>
  </template>
  
  <script>
  import userService from '../../services/user.service'
  import schoolService from '../../services/school.service'
  export default {
    name: 'SchoolAccount',
    data() {
      return {
        search: '',
        schoolAccountGroups: [
        ],
        deleteDialog: false,
        schoolAccountToDelete: null,
        addDialog: false,
        schoolsList: [],
        accountCount: 1,
        newAccount: {
          school: '',
        },
        newAccounts: [],
        successDialog: false,
        addedCSV: [],
        editDialog: false,
        editingSchoolAccount: {
          name: '',
          username: '',
          password: '',
          email: '',
          phone: '',
          sex: '',
          school: {name:''}
        },
      }
    },
    async mounted() {
      await this.getUserInfo();
      await this.getSchoolAccountByAdmin();
    },
    methods: {
      async getSchoolAccountByAdmin() {
        const response = await userService.getSchoolAccountByAdmin();
        console.log(response.data);
        this.schoolAccountGroups = response.data;
      },
      async getUserInfo() {
        const response = await userService.getUserInfo(localStorage.getItem('user_id'));
        this.newAccount.school = response.data.school;
      },
      async getSchools() {
        const response = await schoolService.getAllSchools();
        this.schoolsList = response;
      },
      async addSchoolAccount() {
        await this.getSchools();
        this.addDialog = true;
        this.initializeNewAccounts();
      },
      initializeNewAccounts() {
        this.newAccounts = Array(parseInt(this.accountCount)).fill().map(() => ({
          name: '',
          username: this.randomAccount(),
          password: this.randomPassword(),
          email: '',
          school: this.newAccount.school
        }));
      },
      randomAccount() {
        return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
      },
      randomPassword() {
        return Math.random().toString(36).substring(2, 15);
      },
      incrementCount() {
        this.accountCount = parseInt(this.accountCount) + 1;
        this.initializeNewAccounts();
      },
      decrementCount() {
        if (this.accountCount > 1) {
          this.accountCount = parseInt(this.accountCount) - 1;
          this.initializeNewAccounts();
        }
      },
      closeAddDialog() {
        this.addDialog = false;
        this.newAccount.school='';
        this.initializeNewAccounts();
      },
      confirmAdd() {
        // 檢查必填欄位
        for (const account of this.newAccounts) {
          if (!account.username || !account.password) {
            alert('帳號和密碼為必填欄位');
            return;
          }
        }

        // 保存要下載的資料
        this.addedCSV = {
          school: this.newAccount.school,
          accounts: [...this.newAccounts]  // 創建深拷貝
        };
        
        userService.addSchoolAccountByAdmin(this.newAccount,this.newAccounts)
        .then(() => {
          this.closeAddDialog();
          this.successDialog=true;
          this.getSchoolAccountByAdmin();
        })
        .catch(err => {
          console.log(err)
          alert(err.message)
        });
      },
      downloadAddedCSV() {
        // 使用保存的資料
        const headers = ['學校', '姓名', '帳號', '密碼', '信箱', '電話'];
        let csvContent = headers.join(',') + '\n';
        
        this.addedCSV.accounts.forEach(account => {
          const row = [
            this.addedCSV.school.name,
            account.name || '',
            account.username || '',
            account.password || '',
            account.email || '',
            account.phone || ''
          ].map(field => `"${field}"`).join(',');
          csvContent += row + '\n';
        });
        
        // 添加 BOM 以確保 Excel 正確顯示中文
        const BOM = '\uFEFF';
        const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `新增教師帳號_${new Date().toLocaleDateString()}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      },
      downloadCSV() {
        // 準備 CSV 內容
        const headers = ['學校', '姓名', '帳號', '密碼', '信箱', '電話'];
        let csvContent = headers.join(',') + '\n';
        
        // 將所有學校的帳號資料合併
        this.schoolAccountGroups.forEach(group => {
          group.accounts.forEach(account => {
            const row = [
              group.schoolName,
              account.name || '',
              account.username || '',
              account.password || '',
              account.email || '',
              account.phone || ''
            ].map(field => `"${field}"`).join(',');
            csvContent += row + '\n';
          });
        });
        
        // 添加 BOM 以確保 Excel 正確顯示中文
        const BOM = '\uFEFF';
        const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `教師帳號資料_${new Date().toLocaleDateString()}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      },
      editSchoolAccount(schoolAccount) {
        this.editingSchoolAccount = schoolAccount;
        this.getSchools(); // 獲取學校列表
        this.editDialog = true;
      },
      deleteSchoolAccount(schoolAccount) {
        this.schoolAccountToDelete = schoolAccount;
        this.deleteDialog = true;
      },
      confirmDelete() {
        // Implement your delete logic here
        userService.deleteSchoolAccountByAdmin(this.schoolAccountToDelete._id).then(()=>{
          this.getSchoolAccountByAdmin();
        });
        console.log('Deleting teacher:', this.schoolAccountToDelete);
        
        // Close the dialog
        this.deleteDialog = false;
        this.schoolAccountToDelete = null;
      },
      async confirmEdit() {
        // 檢查必填欄位
        if (!this.editingSchoolAccount.username || !this.editingSchoolAccount.password) {
          alert('帳號和密碼為必填欄位');
          return;
        }
        
        try {
          await userService.updateSchoolAccountByAdmin(this.editingSchoolAccount);
          await this.getSchoolAccountByAdmin(); // 重新獲取教師列表
          this.editDialog = false;
        } catch (error) {
          console.error('更新失敗:', error);
          alert('更新失敗，請稍後再試');
        }
      }
    },
    computed: {
      filteredSchoolAccounts() {
        if (!this.search) {
          return this.schoolAccountGroups;
        }

        const searchTerm = this.search.toLowerCase().trim();
        
        return this.schoolAccountGroups.filter(group => {
          // 檢查學校名稱
          const schoolMatch = group.schoolName.toLowerCase().includes(searchTerm);
          
          // 檢查帳號內的資料
          const hasMatchingAccounts = group.accounts.some(account => 
            account.name?.toLowerCase().includes(searchTerm) ||
            account.username?.toLowerCase().includes(searchTerm) ||
            account.email?.toLowerCase().includes(searchTerm)
          );
          
          // 如果學校名稱或任何帳號符合搜尋條件，就回傳該群組
          if (schoolMatch) {
            return true;
          }
          
          if (hasMatchingAccounts) {
            // 只回傳符合條件的帳號
            return {
              ...group,
              accounts: group.accounts.filter(account =>
                account.name?.toLowerCase().includes(searchTerm) ||
                account.username?.toLowerCase().includes(searchTerm) ||
                account.email?.toLowerCase().includes(searchTerm)
              )
            };
          }
          
          return false;
        });
      }
    }
  }
  </script>
  
  <style scoped>
  .v-data-table ::v-deep th {
    font-weight: bold !important;
    color: rgba(0, 0, 0, 0.87) !important;
  }
  
  .v-data-table ::v-deep td {
    border-bottom: 1px solid #e0e0e0 !important;
  }
  
  .v-icon {
    cursor: pointer;
  }
  
  .v-icon:hover {
    opacity: 0.7;
  }
  
  .v-text-field ::v-deep .v-input__slot {
    background-color: #f5f5f5 !important;
  }
  </style> 